import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import fileManagerApi from "../api/fileManagerApi";

// create slice
const name = "fileManager";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const action = createAction();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const fileManagerActions = {
  ...slice.actions,
  ...extraActions,
  // ...action,
};
export const fileManagerReducer = slice.reducer;
// implementation

function createInitialState() {
  return {
    lstFiles: [],
    fileImageUrl: null,
    fileImages : []
  };
}

function createReducers() {
  return {
    setUrlImageUp,
    setUrlImageList
  };

  function setUrlImageUp(state, action) {
    state.fileImageUrl = action.payload;
  }

  function setUrlImageList(state, action) {
    state.fileImages = action.payload;
  }

}

function createExtraActions() {
  return {
    getFiles: getFiles(),
  };

  function getFiles() {
    return createAsyncThunk(
      `${name}/getFiles`,
      async (data) => await fileManagerApi.getFiles(data)
    );
  }
}

function createExtraReducers() {
  return {
    ...getFiles(),
  };

  function getFiles() {
    const { pending, fulfilled, rejected } = extraActions.getFiles;
    return {
      [pending]: (state) => {
        state.lstFiles = [];
      },
      [fulfilled]: (state, action) => {
        const data = action.payload;
        state.lstFiles = data;
      },
      [rejected]: (state, action) => {
        state.lstFiles = [];
      },
    };
  }
}
